const prefix = 'nxt';
const iconName = 'callTransferSolid';
const width = 21;
const height = 21;
const ligatures = [];
const unicode = '';
const svgPathData = [
  'M17.5898 15.6484L14.5273 14.3359C14.4453 14.3086 14.3633 14.2812 14.2539 14.2812C14.0625 14.2812 13.8711 14.3906 13.7617 14.5273L12.3945 16.1953C10.2617 15.1836 8.56641 13.4883 7.55469 11.3555L9.22266 9.98828C9.35938 9.87891 9.46875 9.6875 9.46875 9.46875C9.46875 9.38672 9.44141 9.30469 9.41406 9.22266L8.10156 6.16016C7.99219 5.91406 7.74609 5.75 7.47266 5.75C7.44531 5.75 7.39062 5.77734 7.33594 5.77734L4.49219 6.43359C4.19141 6.51562 4 6.76172 4 7.0625C4 14.0898 9.66016 19.75 16.6875 19.75C16.9883 19.75 17.2344 19.5586 17.3164 19.2578L17.9727 16.4141C17.9727 16.3594 17.9727 16.3047 17.9727 16.2773C17.9727 16.0039 17.8086 15.7578 17.5898 15.6484Z',
  'M13 8.75C13 8.96875 13.1562 9.125 13.375 9.125H16.5V10.75C16.5 11.0938 16.8906 11.25 17.1406 11.0156L19.8906 8.26562C20.0312 8.125 20.0312 7.89062 19.8906 7.73438L17.1406 5C16.8906 4.76562 16.5 4.92188 16.5 5.26562V6.875H13.375C13.1562 6.875 13 7.04688 13 7.25V8.75Z',
];

const definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [width, height, ligatures, unicode, svgPathData],
};

const nxtCallTransferSolid = definition;

export { definition, nxtCallTransferSolid, prefix, iconName, width, height, ligatures, unicode, svgPathData };
